import React, { useState } from "react";
import { AiOutlineDownload } from "react-icons/ai";

const ExportDataUI1 = ({
  Tags = [],
  Selectors = [],
  dates=[],
  scores=[],
  onExport,
  selectedAssessment,
  onSelectAssessment,
  onSelectScoreRange,
  selectedResumes,
  onSelectResumes,
  
  selectedFormat,
  onSelectFormat,
}) => {

  const [ selectedDateRange, onSelectDateRange] = useState("")
  const [selectedResume1, setSelectedResume1] = useState("");
  const [isCustomDate, setIsCustomDate] = useState(false);
  const [isCustomScore, setIsCustomScore] = useState(false);
  // const [selectedTags, setSelectedTags] = useState("");
  

  const [selectedApplicant, setSelectedApplicant] = useState("");
  const [currentTab, setCurrentTab] = useState(-1);
  const ExportFormat=[
    { name: "Pdf", action: () => setCurrentTab(0), id: 0 },
              { name: "Xls", action: () => setCurrentTab(1), id: 1 },
              { name: "Csv", action: () => setCurrentTab(2), id: 2 },
              { name: "Json", action: () => setCurrentTab(3), id: 3 },
  ]
  


  
  const handleDateRangeChange = (e) => {
    const value = e.target.value;
    if (value === "custom") {
      setIsCustomDate(true);
    } else {
      setIsCustomDate(false);
      
    }
  };

  const handleScoreRangeChange = (e) => {
    const value = e.target.value;
    if (value === "custom") {
      setIsCustomScore(true);
    } else {
      setIsCustomScore(false);
    }
  };
  return (
    <div className="max-w-3xl mx-auto p-16 bg-white rounded-lg shadow-md">
      <div className="flex items-baseline">
              <div className="flex top-3  bg-primary2 border  w-10 h-10 rounded-3xl justify-center items-center relative">
           <AiOutlineDownload className="" /></div>
      <h2 className="text-lg font-bold mb-1 ml-4">Export tags</h2>
      </div>
      <p className="text-sm text-gray-500 mb-7 ml-14 ">
        Select one option
      </p>

     
      <div className="grid grid-cols-2 gap-4 mb-6">
      <div>
          <label className="block text-sm font-semibold mb-2 ">Select applicants/ Resumes</label>
          <select
            value={selectedResumes}
            onChange={onSelectResumes}
            className= {`w-full border ${(onSelectResumes === "") ? "text-gray-500" : "text-primary" } rounded-lg p-2`}
            
          >
            <option className="text-gray-500" value="applicants">Applicants</option>
            <option className="text-gray-500" value="resumes">Resumes</option>
            {Selectors.map((Selector) => (
            <option key={Selector.id} value={Selector.id}>
              {Selector.name}
            </option>
          ))}
        
          </select>
        
        </div>

        <div>
          <label className="block text-sm font-semibold mb-2">Select tag</label>
          <select
            value={selectedAssessment}
            onChange={onSelectAssessment}
            className={`w-full border ${(selectedAssessment === "") ? "text-gray-500" : "text-primary" }   rounded-lg p-2 `}
            
          >
            <option className="text-gray-500" value="AllTags">All Tags</option>
            <option className="text-gray-500" value="UIDevelopers">UI Developers</option>
            <option className="text-gray-500" value="backendengineers">backend engineers</option>
            <option className="text-gray-500" value="nodejsinterns">node js interns</option>
            <option className="text-gray-500" value="flutterinterns">flutter interns</option>
            {Tags.map((tag) => (
            <option key={tag.id} value={tag.id}>
              {tag.name}
            </option>
          ))}
          </select>

         
        </div>
        
      </div>
      
      <div className="grid grid-cols-2 gap-4 mb-6">
      <div>
          <label className="block text-sm font-semibold mb-2 ">Date Range</label>
          <select
            value={selectedAssessment}
            onChange={onSelectAssessment}
            className={`w-full border ${(selectedAssessment === "") ? "text-gray-500" : "text-primary" }  rounded-lg p-2`}
            onClick={(e) => handleDateRangeChange(e)}
          >
            <option  className="text-gray-500" value="">All dates</option>
            <option  className="text-gray-500" value="lastWeek">last week</option>
            <option  className="text-gray-500" value="last15Days">last 15 days</option>
            <option  className="text-gray-500" value="last30Days">last 30 days</option>
            <option  className="text-gray-500" value="custom">Custom Dates</option>
            {dates.map((date) => (
            <option key={date.id} value={date.id}>
              {date.name}
            </option>
          ))}
          </select>

          {isCustomDate && (
          <div className="grid grid-cols-2 gap-4 mb-6">
        <div>
          <label className="block text-xs font-semibold mt-4">Start date</label>
          <input
            type="date"
            onChange={(e) => onSelectDateRange("start", e.target.value)}
            
            className="w-full border border-gray-300 text-sm rounded-lg p-1"
           
          />
        </div>

        <div>
          <label className="block text-xs font-semibold mt-4">End date</label>
          <input
            type="date"
            onChange={(e) => onSelectDateRange("end", e.target.value)}
            className="w-full border border-gray-300 text-sm rounded-lg p-1"
          />
        </div>
      </div>
          )}
        </div>

        <div>
          <label className="block text-sm font-semibold  mb-2">Score Range</label>
          <select
            value={selectedAssessment}
            onChange={onSelectAssessment}
            className={`w-full border ${(selectedAssessment === "") ? "text-gray-500" : "text-primary" } rounded-lg p-2`}
            onClick={(e) => handleScoreRangeChange(e)}
          >
            <option  className="text-gray-500" value="">All scores</option>
            <option  className="text-gray-500" value="above90">Above 90%</option>
            <option  className="text-gray-500" value="70-89">70-89%</option>
            <option  className="text-gray-500" value="below70">less than 70%</option>
            <option  className="text-gray-500" value="custom">Custom score</option>
            {scores.map((score) => (
            <option key={score.id} value={score.id}>
              {score.name}
            </option>
          ))}
          </select>
          

          {isCustomScore && (
          <div className="grid grid-cols-2 gap-4 mb-6">
        <div>
          <label className="block text-xs font-semibold  mt-4">
            Minimum score (%)
          </label>
          <input
            type="number"
            onChange={(e) => onSelectScoreRange("min", e.target.value)}
            className="w-full border border-gray-300 text-sm rounded-lg p-1"
            placeholder="Minimum score"
          />
        </div>
        <div>
          <label className="block text-xs font-semibold  mt-4">
            Maximum score (%)
          </label>
          <input
            type="number"
            onChange={(e) => onSelectScoreRange("max", e.target.value)}
            className="w-full border border-gray-300 text-sm rounded-lg p-1"
            placeholder="Maximum score"
          />
        </div>
      </div>
          )}
        </div>
        
      </div>
      
      

      

      {/* Export Format */}
      <div className="mb-6">
          <label className="block text-2xl font-normal mb-4">
            Select Export Format
          </label>
         
          <div className="flex items-center justify-between ">
            {
          ExportFormat.map((format) => (
          <div key={format.id} className={`flex items-center  ${currentTab === format.id ? "border border-primary" : "border border-gray-500" } px-5 min-w-[10vw] py-2 rounded-lg justify-between  relative`}>
            <span className="text-sm">{format.name}</span>

            <input
              type="radio"
              name="exportFormat"
              onChange={format.action}
              className="peer h-3 w-3 cursor-pointer appearance-none rounded-full border border-slate-300 checked:border-primary"
            />
             
             <div className="absolute  bg-primary w-2 h-2 rounded-full opacity-0 peer-checked:opacity-100 top-1/2 right-[1.12em] transform -translate-x-1/2 -translate-y-1/2" ></div>
          </div>
          
            ))}
          </div>
        </div>


      {/* Export Button */}
      <div className="text-right">
        <button
          onClick={onExport}
          className="bg-orange-500 mt-6 mr-72 text-black py-2 px-6 rounded-lg justify-center items-center"
        >
          Export
        </button>
      </div>
    </div>
  );
};

export default ExportDataUI1;
